import { useMutation } from '@tanstack/react-query'
import type { CreateCorrectionRequest } from '@wf/shared'
import { api } from '../api/client'

/**
 * Zeit-Korrektur an den Chef einreichen. Keine Cache-Invalidierung: die Liste offener Anfragen sieht nur
 * der Chef (eigene Welle), der Mitarbeiter bekommt hier nur die Bestätigung des Absendens.
 */
export function useCreateCorrection() {
  return useMutation({ mutationFn: (body: CreateCorrectionRequest) => api.createCorrection(body) })
}
